type NonZeroDigit = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9';
type Digit = '0' | NonZeroDigit;
export type NumberString = Digit | '${NonZeroDigit}${UnsignedNumber}';

export type TextRelationType = ERelationType | NumberString;

export enum EEntityType {
  banner = 'banner',
  corporateDesign = 'corporateDesign',
  directTicket = 'directTicket',
  footer = 'footer',
  footerAddressArea = 'footer_addressArea',
  footerLogoArea = 'footer_logoArea',
  footerPaymentArea = 'footer_paymentArea',
  footerLinkArea = 'footer_linkArea',
  generalArea = 'generalArea',
  generic = 'generic',
  header = 'header',
  loginLogout = 'loginLogout',
  paymentProviders = 'paymentProviders',
  privateArea = 'privateArea',
  registration = 'registration',
  shoppingCart = 'shoppingCart',
  salutation = 'salutation',
  subscription = 'subscription',
  test = 'test',
  ticket = 'ticket',
  ticketConfiguration = 'ticketConfiguration',
  ticketButton = 'ticketButton',
  journeyPlanner = 'journeyPlanner',
  customTile = 'customTile',
  customTileSection = 'customTileSection',
  startScreen = 'startScreen',
  relationSearch = 'relationSearch',
  removePaymentMethod = 'removePaymentMethod',
  onDemandTicketConfiguration = 'onDemandTicketConfiguration',
  proofOfPurchaseDate = 'proofOfPurchaseDate',
  proofOfPurchaseNumber = 'proofOfPurchaseNumber',
  ticketCategory = 'ticketCategory',
  orderHistory = 'orderHistory',
  cancelOrderMail = 'cancelOrderMail',
  appearance = 'appearance',
}

export enum ERelationType {
  additionalData = 'additionalData',
  imageAlt = 'imageAlt',
  iconText = 'iconText',
  headline = 'headline',
  client = 'client',
  date = 'date',
  dateInputError = 'dateInputError',
  dateTimeInputError = 'dateTimeInputError',
  timeInputError = 'timeInputError',
  subHeadline = 'subHeadline',
  accountIcon = 'accountIcon',
  customTile = 'customTile',
  confirmation = 'confirmation',
  text = 'text',
  url = 'url',
  loginButton = 'loginButton',
  loginHeader = 'loginHeader',
  email = 'email',
  password = 'password',
  warning = 'warning',
  separation = 'separation',
  register = 'register',
  passwordReset = 'passwordReset',
  passwordResetLink = 'passwordResetLink',
  passwordResetDisabled = 'passwordResetDisabled',
  paymentInfoIcon = 'paymentInfoIcon',
  privateAreaLabel = 'privateAreaLabel',
  accountName = 'accountName',
  userInfo = 'userInfo',
  descriptionText = 'descriptionText',
  headlinePhoto = 'headlinePhoto',
  descriptionPhotoText = 'descriptionPhotoText',
  uploadButtonText = 'uploadButtonText',
  deleteButtonText = 'deleteButtonText',
  saveButtonText = 'saveButtonText',
  saveButtonTextDisabled = 'saveButtonTextDisabled',
  paymentInfoLabel = 'paymentInfoLabel',
  directTicketsLabel = 'directTicketsLabel',
  postalCodeError = 'postalCodeError',
  noOptions = 'noOptions',
  directTicketsDescriptionText = 'directTicketsDescriptionText',
  paymentInfoDirectAddLabel = 'paymentInfoDirectAddLabel',
  paymentInfoDirectAddDisabled = 'paymentInfoDirectAddDisabled',
  aboTicketsDescriptionText = 'aboTicketsDescriptionText',
  aboTicketsLabel = 'aboTicketsLabel',
  aboToggle = 'aboToggle',
  accessDenied = 'accessDenied',
  dateFormat = 'dateFormat',
  timeFormat = 'timeFormat',
  departure = 'departure',
  maxAmountExceeded = 'maxAmountExceeded',
  arrival = 'arrival',
  timeFrom = 'timeFrom',
  editJourney = 'editJourney',
  from = 'from',
  to = 'to',
  accountDataEmail = 'accountDataEmail',
  accountDataRegistrationDisabled = 'accountDataRegistrationDisabled',
  addressDataCity = 'addressDataCity',
  addressDataCountry = 'addressDataCountry',
  addressDataExtra = 'addressDataExtra',
  addressDataHouseNumber = 'addressDataHouseNumber',
  addressDataPostalCode = 'addressDataPostalCode',
  addressDataStreet = 'addressDataStreet',
  addToConfiguration = 'addToConfiguration',
  addToConfigurationDisabled = 'addToConfigurationDisabled',
  addressDataHeading = 'addressDataHeading',
  allTime = 'allTime',
  amazonPay = 'amazonPay',
  applePay = 'applePay',
  amount = 'amount',
  back = 'back',
  backDisabled = 'backDisabled',
  backToShop = 'backToShop',
  bonVoyo = 'bonVoyo',
  button = 'button',
  cancel = 'cancel',
  cancelled = 'cancelled',
  checkout = 'checkout',
  choosePayment = 'choosePayment',
  close = 'close',
  complete = 'complete',
  switchDisabled = 'switchDisabled',
  continue = 'continue',
  continueAsGuest = 'continueAsGuest',
  continueTicketConfig = 'continueTicketConfig',
  continueTicketConfigDisabled = 'continueTicketConfigDisableded',
  creditCard = 'creditCard',
  defaultPaymentProvider = 'defaultPaymentProvider',
  deleteAccountButtonLabel = 'deleteAccountButtonLabel',
  deleteAccountDescriptionLabel = 'deleteAccountDescriptionLabel',
  deleteAccountLabel = 'deleteAccountLabel',
  description = 'description',
  detailsTitle = 'detailsTitle',
  directTicketsPageHeading = 'directTicketsPageHeading',
  directToggle = 'directToggle',
  edit = 'edit',
  emptyCart = 'emptyCart',
  errorPageTitle = 'errorPageTitle',
  now = 'now',
  in15Minutes = 'in15Minutes',
  in60Minutes = 'in60Minutes',
  existingCustomerCustomerNumber = 'existingCustomerCustomerNumber',
  finePrint = 'finePrint',
  fixedPriceHeading = 'fixedPriceHeading',
  googlePay = 'googlePay',
  hasToBeValidEmail = 'hasToBeValidEmail',
  info = 'info',
  inProgress = 'inProgress',
  loading = 'loading',
  loadingDirectTicketCheckout = 'loadingDirectTicketCheckout',
  loadingDirectTicketOptions = 'loadingDirectTicketOptions',
  loadingDirectTicketOwnerData = 'loadingDirectTicketOwnerData',
  loadPassengerData = 'loadPassengerData',
  loadingDirectTicketPersonalData = 'loadingDirectTicketPersonalData',
  loadingDirectTickets = 'loadingDirectTickets',
  loadingDirectTicketValidation = 'loadingDirectTicketValidation',
  loadingSubscriptionTickets = 'loadingSubscriptionTickets',
  newCustomerFirstName = 'newCustomerFirstName',
  newCustomerLastName = 'newCustomerLastName',
  newCustomerSalutation = 'newCustomerSalutation',
  newCustomerTelephone = 'newCustomerTelephone',
  noErrors = 'noErrors',
  noPaymentType = 'noPaymentType',
  numberOfPeople = 'numberOfPeople',
  persons = 'persons',
  orderDate = 'orderDate',
  orderNumber = 'orderNumber',
  orderStatus = 'orderStatus',
  pageNotFound = 'pageNotFound',
  passengerData = 'passengerData',
  passwordError = 'passwordError',
  payment = 'payment',
  paymentAddress = 'paymentAddress',
  paymentInfoAboAddLabel = 'paymentInfoAboAddLabel',
  paymentProvider = 'paymentProvider',
  paymentProviderInfo = 'paymentProviderInfo',
  paypal = 'paypal',
  payDirect = 'payDirect',
  paymentType = 'paymentType',
  pendingPaymentVerification = 'pendingPaymentVerification',
  personalData = 'personalData',
  personalDataHeading = 'personalDataHeading',
  personalDataBirthdate = 'personalDataBirthdate',
  prePay = 'prePay',
  price = 'price',
  privateDataHint = 'privateDataHint',
  receiveTicket = 'receiveTicket',
  receiveTicketInfo = 'receiveTicketInfo',
  relationHeading = 'relationHeading',
  onboardingTitle = 'onboardingTitle',
  onboardingCompleteButton = 'onboardingCompleteButton',
  registryTos = 'registryTos',
  rejected = 'rejected',
  remove = 'remove',
  removeTicket = 'removeTicket',
  removeTicketFromCart = 'removeTicketFromCart',
  reservation = 'reservation',
  save = 'save',
  saveDisabled = 'saveDisabled',
  search = 'search',
  searchDisabled = 'searchDisabled',
  sepaDebit = 'sepaDebit',
  sixMonths = 'sixMonths',
  shoppingCartButtonAlternativeLabel = 'shoppingCartButtonAlternativeLabel',
  shoppingCartButtonCompleteLabel = 'shoppingCartButtonCompleteLabel',
  shoppingCartButtonContinueLabel = 'shoppingCartButtonContinueLabel',
  shoppingCartCountLabel = 'shoppingCartCountLabel',
  shoppingCartEmptyText = 'shoppingCartEmptyText',
  shoppingCartLabel = 'shoppingCartLabel',
  shoppingCartVatLabel = 'shoppingCartVatLabel',
  shoppingCartPassengerDataLabel = 'shoppingCartPassengerDataLabel',
  shoppingCartTicketDeleteLabel = 'shoppingCartTicketDeleteLabel',
  shoppingCartTicketEditLabel = 'shoppingCartTicketEditLabel',
  shoppingCartTicketInfoLabel = 'shoppingCartTicketInfoLabel',
  shoppingCartPriceLabel = 'shoppingCartPriceLabel',
  shoppingCartPriceNetLabel = 'shoppingCartPriceNetLabel',
  shoppingCartTicketLabel = 'shoppingCartTicketLabel',
  status = 'status',
  subscriptionShoppingCartLabel = 'subscriptionShoppingCartLabel',
  subscriptionShoppingCartHint = 'subscriptionShoppingCartHint',
  tab = 'tab',
  thirtyDays = 'thirtyDays',
  title = 'title',
  ticketAmount = 'ticketAmount',
  ticketAmountDecreaseDisabled = 'ticketAmountDecreaseDisabled',
  ticketAmountIncreaseDisabled = 'ticketAmountIncreaseDisabled',
  ticketIsForMe = 'ticketIsForMe',
  saveFellowTravelersLabel = 'saveFellowTravelersLabel',
  ticketOptions = 'ticketOptions',
  totalPrice = 'totalPrice',
  tickets = 'tickets',
  travelData = 'travelData',
  unknown = 'unknown',
  buttonText = 'buttonText',
  sendMail = 'sendMail',
  sendMailLink = 'sendMailLink',
  otherTicketsSectionTitle = 'otherTicketsSectionTitle',
  fixedPriceTileTitle = 'fixedPriceTileTitle',
  fixedPriceTileSubtitle = 'fixedPriceTileSubtitle',
  fixedPriceTicketTitle = 'fixedPriceTicketTitle',
  origin = 'origin ',
  destination = 'destination',
  via = 'via',
  startDate = 'startDate',
  shortMonday = 'shortMonday',
  shortTuesday = 'shortTuesday',
  shortWednesday = 'shortWednesday',
  shortThursday = 'shortThursday',
  shortFriday = 'shortFriday',
  shortSaturday = 'shortSaturday',
  shortSunday = 'shortSunday',
  monday = 'monday',
  tuesday = 'tuesday',
  wednesday = 'wednesday',
  thursday = 'thursday',
  friday = 'friday',
  saturday = 'saturday',
  sunday = 'sunday',
  january = '1',
  february = '2',
  march = '3',
  april = '4',
  may = '5',
  june = '6',
  july = '7',
  september = '8',
  august = '9',
  october = '10',
  november = '11',
  december = '12',
  reset = 'reset',
  firstName = 'firstName',
  lastName = 'lastName',
  iban = 'iban',
  bic = 'bic',
  creditInstitute = 'creditInstitute',
  sepaAgreement = 'sepaAgreement',
  proofOfPurchaseNumber = 'proofOfPurchaseNumber',
  proofOfPurchaseDate = 'proofOfPurchaseDate',
  noTicketFoundForCategory = 'noTicketFoundForCategory',
  orderHistoryResend = 'orderHistoryResend',
  orderHistoryDownload = 'orderHistoryDownload',
  orderHistoryCancellableUntil = 'orderHistoryCancellableUntil',
  orderHistoryCancellationReasonLabel = 'orderHistoryCancellationReasonLabel',
  vehicleAvailabilityCheck = 'vehicleAvailabilityCheck',
  noConnectionAvailable = 'noConnectionAvailable',
  additionalInformation = 'additionalInformation',
  combination = 'combination',
  onDemandTicket = 'onDemandTicket',
  comfortSurcharge = 'comfortSurcharge',
  checkVehicle = 'checkVehicle',
  onDemandRequestingLoading = 'onDemandRequestingLoading',
  checkingVehicleLoading = 'checkingVehicleLoading',
  onDemandBookingLoading = 'onDemandBookingLoading',
  noConnection = 'noConnection',
  furtherDetails = 'furtherDetails',
  passengerType = 'passengerType',
  existingTicket = 'existingTicket',
  addExtra = 'addExtra',
  addPassenger = 'addPassenger',
  ticketSelection = 'ticketSelection',
  actualTimes = 'actualTimes',
  deviationWarning = 'deviationWarning',
  reservedUntil = 'reservedUntil',
  existingTicketActive = 'existingTicketActive',
  comfortSurchargeLabel = 'comfortSurchargeLabel',
  comfortSurchargeExistingTicket = 'comfortSurchargeExistingTicket',
  totalAmount = 'totalAmount',
  next = 'next',
  onDemandReservation = 'onDemandReservation',
  goToCheckout = 'goToCheckout',
  thankYou = 'thankYou',
  customerData = 'customerData',
  personalDetails = 'personalDetails',
  availableDepartures = 'availableDepartures',
  chooseConnection = 'chooseConnection',
  onDemandExtras = 'onDemandExtras',
  onDemandExtra = 'onDemandExtra',
  chooseExtra = 'chooseExtra',
  noSpace = 'noSpace',
  remaining = 'remaining',
  onDemandPassenger = 'passenger',
  attention = 'attention',
  onDemandHint = 'onDemandHint',
  onDemandExistingTicketHintHeadline = 'onDemandExistingTicketHintHeadline',
  onDemandExistingTicketHint = 'onDemandExistingTicketHint',
  onDemandEntfaellt = 'onDemandEntfaellt',
  onDemandTicketNumber = 'onDemandTicketNumber',
  onDemandOrderOperator = 'onDemandOrderOperator',
  onDemandOrderChangeableUntil = 'onDemandOrderChangeableUntil',
  onDemandOrderCancellableUntil = 'onDemandOrderCancellableUntil',
  onDemandOrderNotCancellable = 'onDemandOrderNotCancellable',
  onDemandOrderExistingPublicTransportTickets = 'onDemandOrderExistingPublicTransportTickets',
  onDemandTripDate = 'onDemandTripDate',
  noExistingTicketLabel = 'noExistingTicketLabel',
  onDemandPaymentMethod = 'onDemandPaymentMethod',
  onDemandAddPaymentMethod = 'onDemandAddPaymentMethod',
  onDemandPaymentFailed = 'onDemandPaymentFailed',
  onDemandCompleteOrder = 'onDemandCompleteOrder',
  onDemandOrderBackToWebshop = 'onDemandOrderBackToWebshop',
  onDemandOrderTechnicalCancellationReason = 'onDemandOrderTechnicalCancellationReason',
  onDemandOrderCancellationCompleted = 'onDemandOrderCancellationCompleted',
  fellowTravelersLabel = 'fellowTravelersLabel',
  deleteFellowTravelerButtonText = 'deleteFellowTravelerButtonText',
  createFellowTravelerButtonText = 'createFellowTravelerButtonText',
  cancelOrderMail = 'cancelOrderMail',
}
